import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-10 py-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_4 = { class: "bg-white mt-6 p-6 px-4 rounded border" }
const _hoisted_5 = { class: "flex items-center justify-between mt-4" }
const _hoisted_6 = {
  class: "block",
  href: "/directions-import-template.xlsx",
  download: "Шаблон направлений для импортирования.xlsx"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Импортирование направлений из Excel" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_file_reader, {
        type: "file",
        value: _ctx.state.file,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.file) = $event)),
        "is-invalid": _ctx.state_form$.file.$error,
        "validation-errors": _ctx.state_form$.file.$errors,
        accept: ".xlsx",
        disabled: _ctx.state.is_loading,
        placeholder: "Выберите файл (.xlsx)"
      }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, [
          _createVNode(_component_the_button, { class: "primary text small" }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Скачать шаблон ")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_the_button, {
          loading: _ctx.state.is_loading,
          class: "primary small",
          onClick: _ctx.importDirections
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" Импортировать ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}